<template>
  <v-data-table id="segments-table" :items-per-page="10" :headers="headers" :items="segments" class="theme-table">
    <template v-slot:item.color="{ item }">
      <span class="segment-item mr-2" :class="{
        'segment-color-green': item.color === 'green',
        'segment-color-orange': item.color === 'orange',
        'segment-color-purple': item.color === 'purple',
        'segment-color-blue': item.color === 'blue',
        'segment-color-green-dark': item.color === 'green-dark',
        'segment-color-pink': item.color === 'pink'
      }" />
    </template>
    <template v-slot:item.action="{ item }">
      <v-menu offset-y content-class="table-menu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" class="table-menu-trigger">
            Action <v-icon small>expand_more</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item link>
            <v-list-item-title
              @click="updateSegment(item)">Modifier</v-list-item-title>
          </v-list-item>
          <v-list-item link>
            <v-list-item-title
              @click="deleteSegment(item)">Supprimer</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>

<script type="text/javascript">

export default {
  data() {
    return {
      headers: [
        {
          text: 'Code',
          sortable: true,
          value: 'code'
        },
        {
          text: 'Couleur',
          sortable: true,
          value: 'color'
        },
        {
          text: 'Etiquette',
          sortable: true,
          value: 'label'
        },
        {
          text: "Description",
          sortable: true,
          value: 'description'
        },
        {
          text: 'Options',
          sortable: false,
          value: 'action'
        }
      ]
    }
  },
  computed: {
    segments() {
      return this.$store.state.segments.list
    }
  },
  created() {
    this.$store.dispatch('segments/getSegments')
  },
  methods: {
    updateSegment(segment) {
      this.$router.push({ name: 'EditSegment', params: { segment: segment.id } })
    },
    deleteSegment(segment) {
      this.$store.dispatch('segments/deleteSegment', segment)
    }
  }
}

</script>

<style lang="scss">
#segments-table {
  .segment-item {
    display: inline-block;
    border-radius: 50%;
    width: 22px;
    height: 22px;

    &.segment-color-green {
      background-color: $green-lighten-1;
    }

    &.segment-color-orange {
      background-color: $orange-lighten-1;
    }

    &.segment-color-purple {
      background-color: $purple-alt;
    }

    &.segment-color-blue {
      background-color: $blue-base;
    }

    &.segment-color-green-dark {
      background-color: $green-dark;
    }

    &.segment-color-pink {
      background-color: $pink-base;
    }
  }

  .table-menu-trigger {
    background-color: $purple-lighten-3-3;
    color: $black-base;
    box-shadow: none;
    border-radius: 50px;
    font-size: 12px;
    text-transform: initial;
    padding: 5px 15px;
    height: fit-content;
    transition-duration: 0.2s;

    i {
      position: relative;
      top: 1px;
      color: $black-base;
    }

    &:hover,
    &:focus {
      background-color: $color-primary;
      color: white;

      i {
        color: white;
      }
    }
  }

}

.table-menu {
  box-shadow: none !important;
  border-radius: 16px !important;
  border: $border-purple;
  margin-top: 3px;

  .v-list {
    padding-top: 0px;
    padding-bottom: 0px;

    &>.v-list-item {
      min-height: initial;
      text-align: center;
      padding: 5px 10px;

      .v-list-item__title {
        color: $purple-alt;
        font-size: 12px;
      }
    }

    &>.v-list-item:nth-child(2n) {
      background-color: $purple-lighten-3-3;
    }
  }
}
</style>